import SyTaskdetailsPopup from "./sy-taskdetails-popup";

export default SyTaskdetailsPopup;
